import { compact, isEmpty } from 'lodash';
import { GitCompare } from 'lucide-react';

import { getAdvancedSearchSummaryLabel } from '@/components/modules/advanced-search/utils';
import { useSavedItems } from '@/hooks/use-saved-items';
import { ROUTING_SEARCH_URL, SAVED_ITEM_TYPE } from '@/lib/constants';
import { SavedItemModel } from '@/lib/models/saved-item/types';
import { getSavedItemLink } from '@/lib/models/saved-item/utils';
import { getCargoOptionSelectionString } from '@/utils/cargo';
import { trackUser } from '@/utils/tracking';

import { DashboardCard } from '../card';
import { DashboardEmpty } from '../empty';
import { DashboardListItem } from '../list-item';

const DashboardSavedRoutes = () => {
  const { savedItems, deleteSavedItem } = useSavedItems();

  const filteredItems = savedItems.filter((item) => item.type === SAVED_ITEM_TYPE.ROUTE);
  const hasItems = !isEmpty(filteredItems);

  const handleClick = (item: SavedItemModel) => {
    trackUser.event(`Clicked saved item`, { label: item.label, type: item.type, from: 'Dashboard' });
  };

  const handleStarClick = (item: SavedItemModel) => {
    deleteSavedItem(item);
  };

  return (
    <DashboardCard
      title="Starred Routes"
      icon={<GitCompare />}
      ctaHref={hasItems ? ROUTING_SEARCH_URL : ''}
      ctaText="New route search"
    >
      {hasItems && (
        <ul>
          {filteredItems.map((item) => {
            const dataObject = item.data || {};
            const advancedSearchLabel = getAdvancedSearchSummaryLabel(dataObject.advancedSearchParams);
            const cargoSearchLabel = dataObject?.cargoParams
              ? getCargoOptionSelectionString(dataObject.cargoParams)?.string
              : '';
            const filterSearchLabel = compact([advancedSearchLabel, cargoSearchLabel]).join(' ');

            return (
              <DashboardListItem
                key={item.id}
                title={item.label}
                isSaved
                href={getSavedItemLink(item)}
                description={`Filters: ${filterSearchLabel || 'none'}`}
                onItemClick={() => handleClick(item)}
                onStarClick={() => handleStarClick(item)}
              />
            );
          })}
        </ul>
      )}
      {!hasItems && (
        <DashboardEmpty
          title="You have no saved route searches"
          cta="Explore Shipping Routes"
          href={ROUTING_SEARCH_URL}
        />
      )}
    </DashboardCard>
  );
};

export { DashboardSavedRoutes };
